import { Component } from 'react';

const data = [
    {
        id: 1,
        label: 'Do you need access to GSC?',
        content: (
            <div>
                Yes. We need access to Google Search Access in order to retrieve data. We don’t
                share or sell any data. Check out{' '}
                <a
                    href="https://gddash.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    data privacy policy
                </a>
                .
            </div>
        ),
    },
    {
        id: 2,
        label: 'How many domains I can have in my trial?',
        content:
            'You can add as many domains as allowed in your selected plan, but only one domain can be active.',
    },
    {
        id: 3,
        label: 'Do I have access to all features in FREE trial?',
        content: (
            <div>
                You have access to all reports except the following reports:
                <ul>
                    <li>Author Topical Authority</li>
                    <li> Competitive Analysis</li>
                    <li> Search analytics</li>
                </ul>
                To view these reports you must be a paid subscriber.
            </div>
        ),
    },
    {
        id: 4,
        label: 'Can I deactivate and activate other domains in my plan?',
        content:
            'Sure you can, but you can only activate/deactivate domains once every 30 days. Please note that when you deactivate a domain you will not get any data for that period of time as our platform is not collecting, parsing or analyzing that domain.',
    },
    {
        id: 5,
        label: 'Which Plan Should I choose?',
        content: (
            <div>
                It depends on how many pages and search records.
                <ul>
                    <li>Go to your Google Search Console.</li>
                    <li> Click “Discover” on the left hand navigation. </li>
                    <li> Click “Date: Last 3 months”</li>
                    <li> Change to “Last 7 days” and click apply.</li>
                    <li>
                        {' '}
                        Scroll all the way down to “rows per page” and check the total number of
                        pages.
                    </li>
                    <li>
                        {' '}
                        Multiply this number of total pages by 4, this is the estimated number of
                        analyzed pages you need on average per month
                    </li>
                    <li> Choose the plan that is closest to that number of pages.</li>
                </ul>
            </div>
        ),
    },
    {
        id: 6,
        label: 'How can I pay?',
        content: 'We accept all major credit cards. We use Stripe to process all payments',
    },
    {
        id: 7,
        label: 'Will I get an invoice?',
        content: 'Yes, all invoices are in your client’s area.',
    },
    {
        id: 8,
        label: 'How can I cancel?',
        content: (
            <div>
                <div className="mb-15">
                    To <strong>cancel your account</strong> and stop payments, please got to
                    “Settings”, then click the gear icon in the Current Plan” section, then click
                    “Deactivate”.
                </div>
                <div className="mb-15">
                    <strong>To stop a domain</strong> and continue to keep the account (and
                    payments) going, Just deactivate the domain in the domains block the settings
                    page.
                </div>
                <div className="mb-15">You can cancel at anytime:</div>
                <ul>
                    <li>please login to your account</li>
                    <li>
                        go to{' '}
                        <a
                            href="https://app.gddash.com/settings/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://app.gddash.com/settings/
                        </a>
                    </li>
                    <li>Click the gear icon in the “CURRENT PLAN” block</li>
                    <li>click “deactivate”</li>
                </ul>
                <div className="mb-15">
                    You will still have access to the account till end of the payment period.
                </div>
                <div className="mb-15">
                    We will continue to get your data from GSC till paid period ends. This may incur
                    additional charges if you go beyond your plan limits in terms of Discover pages
                    and Search records. To avoid any additional charges, deactivate your domains on
                    the settings page under domains section by switch the toggle off for all your
                    domains.
                </div>
            </div>
        ),
    },
    {
        id: 9,
        label: 'What is your refund policy?',
        content:
            'We have a 14-days FREE trial period where you can cancel at anytime. If you are a paid subscriber, you can still cancel at anytime, we will not charge your credit after the end of the current billing month. Please note we continue to collect and analyze your data till end of the billing period which may result in additional charges if collected Discover Pages and Search records exceed the plan limits.',
    },
    {
        id: 10,
        label: 'Do I need to install anything?',
        content:
            'Absolutely Not. Simply sign in and get started. The only action needed on your end is to connect GSC to GDdash.',
    },
    {
        id: 11,
        label: 'Do you Share my Data?',
        content: (
            <div>
                We will never share your data with any one else. Check our{' '}
                <a
                    href="https://gddash.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </a>
            </div>
        ),
    },
    {
        id: 12,
        label: 'Why was I charged beyond my plan fee?',
        content:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
        id: 13,
        label: 'Do you Share my Data?',
        content: (
            <div>
                <div className="mb-15">
                    Each plan has a set number of Discover Pages and Search Records. Charges apply
                    for exceeding these limits. The cost is based on the number of pages and records
                    we analyze.
                </div>
                <div className="mb-15">
                    Discover Pages are any page that generates Google Discover traffic. Search
                    Records are combination of URL, Keyword, and Device. All data retrieved from
                    Google Search Console..
                </div>
                <div className="mb-15">
                    In other words, If the number of pages and records we get from your Google
                    Search Account at a given month exceeds the plan limits, we charge additional
                    fees to process and analyze these pages.
                </div>
                <div className="mb-15">
                    All additional charges are clearly mentioned on our pricing and registration
                    pages. By signing up, you agreed to these terms.
                </div>
                <div className="mb-15">
                    Unfortunately we can’t stop at the plan limits. Stopping at the limit would
                    compromise the accuracy of our analysis. We aim to keep our monthly fees low for
                    small to medium sites. Larger sites should consider upgrading to avoid extra
                    charges.
                </div>
            </div>
        ),
    },
    {
        id: 14,
        label: 'I cancelled my account but still got charged',
        content: (
            <div>
                <div className="mb-15">
                    We continue to collect data from Google Search Console till the end of the last
                    billing cycle. Cancelation is stopping the service at the end of the billing
                    cycle.
                </div>
                <div className="mb-15">
                    As stated on the pricing and registration pages, all additional discover pages
                    and search records during trial or till the last day of the last billing period
                    are still charged.
                </div>
                <div className="mb-15">
                    When you cancel you plan we continue to provide the service till the end of the
                    billing period or the trial period.
                </div>
            </div>
        ),
    },
];

class Questions extends Component {
    constructor(props) {
        super(props);

        this.onToggleContent = this.onToggleContent.bind(this);

        this.state = {
            showId: 1,
        };
    }

    onToggleContent(id) {
        this.setState({
            showId: this.state.showId === id ? 0 : id,
        });
    }

    render() {
        return (
            <div className="custom-registration-questions">
                <div className="custom-registration-questions-header">
                    Frequently <br /> Asked Questions
                </div>
                <div className="custom-registration-questions-body">
                    {data.map((item) => (
                        <div className="custom-registration-questions-body-item" key={item.id}>
                            <div
                                className={`custom-registration-questions-body-item-header${
                                    this.state.showId === item.id ? ' active' : ''
                                } `}
                                onClick={() => this.onToggleContent(item.id)}
                            >
                                {item.label}
                                {this.state.showId === item.id ? (
                                    <i className="icon-x-close" />
                                ) : (
                                    <i className="icon-plus" />
                                )}
                            </div>
                            <div
                                className={`custom-registration-questions-body-item-content${
                                    this.state.showId === item.id ? ' show' : ''
                                }`}
                            >
                                {item.content}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default Questions;
